import { io } from 'socket.io-client';
import { audioManager } from '../audio/AudioManager.js';

/**
 * Network Manager for Co-op Multiplayer
 * Handles Socket.io communication
 */
export class NetworkManager {
    constructor(game) {
        this.game = game;
        this.socket = null;
        this.isConnected = false;
        this.players = new Map(); // Other players
        this.playerId = null;
    }
    
    /**
     * Connect to server
     * @param {string} serverUrl - Server URL
     * @param {string} race - Player's race
     * @param {string} mode - Game mode
     */
    connect(serverUrl = 'http://localhost:3000', race, mode) {
        if (this.socket) {
            this.disconnect();
        }
        
        this.socket = io(serverUrl, {
            transports: ['websocket'],
            reconnection: true,
            reconnectionDelay: 1000,
            reconnectionAttempts: 5
        });
        
        this.socket.on('connect', () => {
            console.log('Connected to server:', this.socket.id);
            this.isConnected = true;
            this.playerId = this.socket.id;
            
            // Join game room
            this.socket.emit('join-game', { race, mode });
        });
        
        this.socket.on('disconnect', () => {
            console.log('Disconnected from server');
            this.isConnected = false;
        });
        
        this.socket.on('player-joined', (data) => {
            console.log('Player joined:', data);
            this.onPlayerJoined(data);
        });
        
        this.socket.on('player-left', (playerId) => {
            console.log('Player left:', playerId);
            this.onPlayerLeft(playerId);
        });
        
        this.socket.on('player-update', (data) => {
            this.onPlayerUpdate(data);
        });
        
        this.socket.on('game-state', (state) => {
            this.onGameStateUpdate(state);
        });
        
        this.socket.on('error', (error) => {
            console.error('Network error:', error);
        });
    }
    
    /**
     * Send player update to server
     * @param {Object} playerData - Player position, rotation, etc.
     */
    sendPlayerUpdate(playerData) {
        if (this.isConnected && this.socket) {
            this.socket.emit('player-update', {
                position: {
                    x: playerData.position.x,
                    y: playerData.position.y,
                    z: playerData.position.z
                },
                rotation: {
                    x: playerData.rotation.x,
                    y: playerData.rotation.y,
                    z: playerData.rotation.z
                },
                health: playerData.health,
                ammo: playerData.ammo
            });
        }
    }
    
    /**
     * Send shooting event
     * @param {Object} shootData - Shooting data
     */
    sendShoot(shootData) {
        if (this.isConnected && this.socket) {
            this.socket.emit('player-shoot', shootData);
        }
    }
    
    /**
     * Handle player joined
     */
    onPlayerJoined(data) {
        // Create remote player representation
        // This would create a visual representation of the other player
        console.log('Creating remote player:', data);
    }
    
    /**
     * Handle player left
     */
    onPlayerLeft(playerId) {
        // Remove remote player
        if (this.players.has(playerId)) {
            const player = this.players.get(playerId);
            // Remove from scene
            this.players.delete(playerId);
        }
    }
    
    /**
     * Handle player update from network
     */
    onPlayerUpdate(data) {
        if (this.players.has(data.id)) {
            const player = this.players.get(data.id);
            // Update remote player position/rotation
            // player.updateFromNetwork(data);
        }
    }
    
    /**
     * Handle game state update
     */
    onGameStateUpdate(state) {
        // Sync game state (enemies, etc.)
        console.log('Game state update:', state);
    }
    
    /**
     * Disconnect from server
     */
    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
        }
        this.isConnected = false;
        this.players.clear();
    }
    
    /**
     * Update network (call in game loop)
     * @param {number} deltaTime - Delta time
     */
    update(deltaTime) {
        if (this.isConnected && this.game.player) {
            // Send player update every frame (throttled on server side)
            this.sendPlayerUpdate({
                position: this.game.player.camera.position,
                rotation: this.game.player.camera.rotation,
                health: this.game.player.health,
                ammo: this.game.player.ammo
            });
        }
    }
}


